'use client';

import {
  Flex,
  Text,
  Popover,
  PopoverContent,
  PopoverBody,
  PopoverArrow,
  PopoverAnchor,
  useDisclosure,
  Box,
  FlexProps,
} from '@chakra-ui/react';
import { FC } from 'react';
import FilterBox from '@/components/UI/Filter/FilterBox';
import {
  IFilterGroup,
  IFilterObject,
} from '@/components/Product/Filters/types';
import FilterItems from '@/components/UI/Filter/FilterItems';

interface FilterGroupsProps {
  filters?: IFilterObject[];
  onFiltersChange?: (val: IFilterObject[]) => void;
  filterGroups: IFilterGroup[];
}
const FilterGroups: FC<FilterGroupsProps> = ({
  filterGroups,
  filters,
  onFiltersChange,
}) => {
  return (
    <Flex gap="0.5rem">
      {filterGroups.map((fG) => (
        <FilterGroup
          key={fG.key}
          filterGroup={fG}
          filters={filters}
          onFiltersChange={onFiltersChange}
        />
      ))}
    </Flex>
  );
};

interface FilterGroupProps {
  filterGroup?: IFilterGroup;
  filters?: IFilterObject[];
  onFiltersChange?: (val: IFilterObject[]) => void;
}
const FilterGroup: FC<FilterGroupProps> = ({
  filterGroup,
  filters = [],
  onFiltersChange,
}) => {
  const { isOpen, onClose, onToggle } = useDisclosure();

  const matchedAndActiveFilters = filters.filter(
    (f) => f.key === filterGroup?.key && filterGroup.items.includes(f.value)
  );
  const count = matchedAndActiveFilters.length;

  const handleClear = () => {
    if (!filterGroup) return;
    const { key } = filterGroup;
    onFiltersChange?.(filters.filter((f) => f.key !== key));
  };

  if (!filterGroup) return null;

  return (
    <Box zIndex="20">
      <Popover isOpen={isOpen} onClose={onClose} placement="bottom-start">
        <FilterGroupPopupAnchor
          isActive={!!count}
          onClick={onToggle}
          count={count}
          filterGroup={filterGroup}
          onClear={handleClear}
        />
        <PopoverContent>
          <PopoverArrow />
          <PopoverBody>
            <FilterItems
              filterGroup={filterGroup}
              filters={filters}
              onFiltersChange={onFiltersChange}
              containerProps={{
                gap: '1rem',
              }}
            />
          </PopoverBody>
        </PopoverContent>
      </Popover>
    </Box>
  );
};

interface FilterGroupPopupAnchorProps {
  isActive?: boolean;
  onClick?: FlexProps['onClick'];
  filterGroup?: IFilterGroup;
  count?: number;
  onClear?: () => void;
}
const FilterGroupPopupAnchor: FC<FilterGroupPopupAnchorProps> = ({
  isActive,
  onClick,
  count,
  filterGroup,
  onClear,
}) => {
  return (
    <PopoverAnchor>
      <Box>
        <FilterBox isActive={isActive} onClick={onClick} onClear={onClear}>
          <Text>
            <Text as="span" textTransform="capitalize">
              {filterGroup?.key}
            </Text>{' '}
            {!!count && <Text as="span">({count})</Text>}
          </Text>
        </FilterBox>
      </Box>
    </PopoverAnchor>
  );
};

export default FilterGroups;
